import React, {Component} from 'react';
import PropTypes from 'prop-types';
//import Background from './Home/back.jpg';
import Home from './Home/Home';
import Speakers from './Speakers/Speakers';
import Registration from './Registration/Registration';
import Info from './Info/Info';
import Program from './Program/Program';
//import Description from './Description/Description';

import AppBar from '@material-ui/core/AppBar';
import Tabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';
import Typography from '@material-ui/core/Typography';
import Slide from '@material-ui/core/Slide';





const styleOtherPages =
  {
    flexGrow: 1,
    width: '100%',
    alignItems: 'center',
    minHeight: '1000px',
    color: '#6a737b',
    
    fontFamily: 'Arial'
  };


 

const AppbarStyleOther = {
  background:  '#009688',
  color: 'white',
  align: 'left',
  position: 'fixed',
  top: 0,
  elevation: '10',
}



function TabContainer({ children }) {
  return (
    <Slide direction="left" in={true} mountOnEnter unmountOnExit >
    <div align="center" component="div"  style={{ width: '90%',  padding: 8 * 3}}>
      {children}
    </div>
    </Slide>
  );
}

TabContainer.propTypes = {
  children: PropTypes.node.isRequired,
};


function App() {
  const [value, setValue] = React.useState(0);

  function handleChange(event, newValue) {
    setValue(newValue);
  }

  return (
    
    <div style={ styleOtherPages}>
      <div>
      <AppBar
              style={ AppbarStyleOther}>
        <Tabs
          centered
          value={value}
          onChange={handleChange}
          indicatorColor="primary"
          textColor="inherit"
          backgroundColor="secondary"       
        >
          <Tab label="Home"  />
          <Tab label="Speakers"  />
          <Tab label="Registration"  />
          <Tab label="Program and abstracts"  />
          <Tab label="Practical Info"  />
     
    
          
        </Tabs>
      </AppBar>
      </div>
      <div>
      {value === 0 && <TabContainer><Home/></TabContainer>}
      {value === 1 && <TabContainer><Speakers></Speakers></TabContainer>}
      {value === 2 && <TabContainer><Registration></Registration></TabContainer>}
      {value === 3 && <TabContainer><Program/></TabContainer>}
      {value === 4 && <TabContainer><Info/></TabContainer>} 
       
      </div>
      </div>
  );
}

export default App;
